import { PropsWithChildren } from 'react'
import clsx from 'clsx'

type LinearSlideAnimationProps = PropsWithChildren<{
  className?: string
  isLoading?: boolean
}>

export const RoundedBorderAnimation = ({ isLoading, children, className }: LinearSlideAnimationProps) => (
  <div className={clsx('relative p-0.5', className)}>
    <div
      className={clsx(
        'absolute left-0 top-0 h-full w-full overflow-hidden rounded-full',
        isLoading
          ? 'animate-spin bg-[linear-gradient(to_right,theme(colors.primary.DEFAULT),theme(colors.secondary.DEFAULT),theme(colors.destructive.DEFAULT),theme(colors.primary.DEFAULT))]'
          : 'bg-transparent',
      )}
    />
    <div className="relative">{children}</div>
  </div>
)
